import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.checkoutButton = null;
    this.openCartIcons = null;
  }

  connectedCallback() {
    this.checkoutButton = this.querySelector('[data-ref="checkout-button"]');

    this.addEventListener('click', (event) => this.#onBackdropClick(event));

    this.checkoutButton.addEventListener('click', (event) => this.#handleCheckoutButtonClick(event));

    document.addEventListener(ThemeEvents.cartUpdated, (event) => this.#handleCartUpdate(event));

    document.addEventListener(ThemeEvents.cartOpen, () => this.open());
    document.addEventListener(ThemeEvents.cartClose, () => this.close());
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartClose, () => this.close());
    document.removeEventListener(ThemeEvents.cartOpen, () => this.open());

    document.removeEventListener(ThemeEvents.cartUpdated, (event) => this.#handleCartUpdate(event));

    this.checkoutButton.removeEventListener('click', (event) => this.#handleCheckoutButtonClick(event));

    this.removeEventListener('click', (event) => this.#onBackdropClick(event));
  }

  #handleCheckoutButtonClick(event) {
    event.target.classList.add('is-loading');
  }

  #handleCartUpdate(event) {
    this.renderCartContents(event.detail.data);
  }

  #onBackdropClick(event) {
    const rect = this.querySelector('.cart-drawer__inner').getBoundingClientRect();
    const isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;

    if (!isInDialog) {
      this.close();
    }
  }

  open() {
    // Nettoyer les classes pour éviter les conflits
    this.classList.remove('is-closing');
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    // Ajouter la classe de fermeture pour déclencher l'animation
    this.classList.add('is-closing');

    // Attendre la fin de l'animation avant de masquer complètement
    setTimeout(() => {
      this.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
    }, 125); // Durée légèrement inférieure à --animation-speed pour éviter les décalages
  }

  isOpen() {
    return this.classList.contains('is-open');
  }

  renderCartContents(parsedState) {
    const section_cart_drawer_id = this.dataset.sectionId;

    const currentCartDrawer = this.querySelector('.cart-drawer__inner');
    const newCartDrawer = new DOMParser().parseFromString(parsedState.sections[section_cart_drawer_id], 'text/html');

    currentCartDrawer.innerHTML = newCartDrawer.querySelector('.cart-drawer__inner').innerHTML;

    setTimeout(() => {
      if (parsedState.itemCount == 0) {
        this.classList.add('cart-drawer--empty');
      } else {
        this.classList.remove('cart-drawer--empty');
      }
    });
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItem extends HTMLElement {
  constructor() {
    super();

    this.removeItemButton = null;
    this.quantitySelectorInput = null;
  }

  connectedCallback() {
    this.removeItemButton = this.querySelector('[data-ref="remove-item"]');
    this.quantitySelectorInput = this.querySelector('[data-ref="quantity-selector-input"]');

    this.removeItemButton?.addEventListener('click', (event) => this.#handleItemRemove(event));
    this.quantitySelectorInput?.addEventListener('change', (event) => this.#handleQuantityInputChange(event));
  }

  disconnectedCallback() {
    this.quantitySelectorInput?.removeEventListener('change', (event) => this.#handleQuantityInputChange(event));
    this.removeItemButton?.removeEventListener('click', (event) => this.#handleItemRemove(event));
  }

  #handleItemRemove(event) {
    event.preventDefault();
    this.#updateLineItemQuantity(this.dataset.index, 0);
  }

  #handleQuantityInputChange(event) {
    event.preventDefault();
    this.#updateLineItemQuantity(this.dataset.index, this.quantitySelectorInput.value);
  }

  #updateLineItemQuantity(line, quantity) {
    this.#enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.closest('cart-drawer').dataset.sectionId,
      sections_url: window.location.pathname,
    });

    fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/json` },
      ...{ body },
    })
      .then((response) => {
        return response.text();
      })
      .then((responsetext) => {
        const parsedResponseText = JSON.parse(responsetext);

        if (parsedResponseText.errors) {
          document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
          return;
        }

        document.dispatchEvent(
          new CartUpdatedEvent(
            {},
            {
              itemCount: parsedResponseText.item_count,
              source: 'cart-drawer-item',
              sections: parsedResponseText.sections,
            },
          ),
        );
      })
      .catch((e) => {
        console.error(e);
        this.#disableLoading();
      })
      .finally(() => {
        this.#disableLoading();
      });
  }

  #enableLoading() {
    this.classList.add('cart-drawer__item--loading');
  }

  #disableLoading() {
    this.classList.remove('cart-drawer__item--loading');
  }
}

if (!customElements.get('cart-drawer-item')) {
  customElements.define('cart-drawer-item', CartDrawerItem);
}
/* ==============================
   UPSELL CART DRAWER
   ============================== */
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    const variantId = parseInt(btn.dataset.variantId);
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Erreur ajout');
        return res.json();
      })
      .then(() => {
        sessionStorage.setItem('reopen-cart', '1');
        window.location.reload();
      })
      .catch((err) => {
        console.error('Erreur upsell:', err);
        btn.disabled = false;
        btn.textContent = 'Ajouter';
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem('reopen-cart') === '1') {
      sessionStorage.removeItem('reopen-cart');
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent(ThemeEvents.cartOpen));
      }, 300);
    }
  });
})();

/* ==============================
   STYLES UPSELL
   ============================== */
(function injectUpsellStyles() {
  if (document.getElementById('cart-upsell-styles')) return;
  const css = `
    .cart-upsell {
      margin: 12px 0 4px;
      padding: 12px 16px;
      background: #f7faf8;
      border-top: 1px solid #ddeee5;
      border-bottom: 1px solid #ddeee5;
    }
    .cart-upsell__label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .06em;
      color: #2d6a4f;
      margin: 0 0 10px;
    }
    .cart-upsell__inner {
      display: flex;
      align-items: flex-start;
      gap: 14px;
    }
    .cart-upsell__image img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 6px;
      display: block;
      flex-shrink: 0;
    }
    .cart-upsell__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      padding-top: 2px;
    }
    .cart-upsell__title {
      font-size: 13px;
      font-weight: 600;
      line-height: 1.35;
      margin: 0;
      color: #1a1a1a;
    }
    .cart-upsell__prices {
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .cart-upsell__price--compare {
      font-size: 12px;
      color: #999;
      text-decoration: line-through;
    }
    .cart-upsell__price--sale {
      font-size: 13px;
      font-weight: 700;
      color: #2d6a4f;
    }
    .cart-upsell__btn {
      margin-top: 2px;
      background: #2d6a4f;
      color: #fff;
      border: none;
      border-radius: 5px;
      padding: 7px 18px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: background .18s ease;
      letter-spacing: .02em;
    }
    .cart-upsell__btn:hover   { background: #1e4d38; }
    .cart-upsell__btn:disabled { opacity: .55; cursor: not-allowed; }
  `;
  const style = document.createElement('style');
  style.id = 'cart-upsell-styles';
  style.textContent = css;
  document.head.appendChild(style);
})();